import { createFileRoute } from "@tanstack/react-router";

import { WhatsAppButton } from "@/components/WhatsApp/WhatsAppButton";
import HotelsList from "@/features/hotels/components/hotels-list/HotelsList";

export const Route = createFileRoute("/_authenticated/hotels/_hotels/list")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <main className="no-footer main h-screen">
      <HotelsList />
      <WhatsAppButton />
    </main>
  );
}
